import { z } from 'zod/v4';

import { createLegacyEntitySchema } from '@sites/entity-migrator';

import { socialLegacyDefaultV0Schema } from './default';
import { socialLegacyZeroV0Schema } from './zero';

/**
 * Discriminated union over the envelope's `type` field. Persisted entities
 * without a `type` field land on the default branch (its `type` literal is
 * `.optional()`); entities tagged `type: 'zero'` land on the zero branch.
 *
 * Like button, the two variants also diverge on the inner data shape: the
 * default branch carries the simple `position` grid (nullish), the zero
 * branch requires the extended-position grid.
 */
const socialLegacyEntityUnion = z.discriminatedUnion('type', [socialLegacyDefaultV0Schema, socialLegacyZeroV0Schema]);

export type LegacySocialDefault = z.infer<typeof socialLegacyDefaultV0Schema>;
export type LegacySocialZero = z.infer<typeof socialLegacyZeroV0Schema>;
export type LegacySocial = LegacySocialDefault | LegacySocialZero;

/**
 * Legacy-only entity: the persisted widget shape is the only version (no v0 yet).
 * Single 'web' variant today; the mini-landing shape becomes a second variant when
 * the widget is unified across apps. When a redesigned `default/v0` lands, this
 * switches to a versioned schema and the variants gain `up` migrations into it.
 */
export const LegacySocialEntitySchema = createLegacyEntitySchema([{ name: 'web', schema: socialLegacyEntityUnion }]);
